import { Link } from 'react-router-dom';

import { useIntl } from '@zenbusiness/application-commons-intl';
import Tab from '@zenbusiness/zui/Tab';
import Tabs from '@zenbusiness/zui/Tabs';

import { billingPaymentMethods, billingSubscriptions } from '#client/constants/routes';
import useCurrentTab from '#client/hooks/useCurrentTab';

export const LOCALIZED_TEXT = {
  paymentMethods: 'dashboard.billing.tabs.paymentMethods',
  subscriptions: 'dashboard.billing.tabs.subscriptions',
  billingTabsAriaLabel: 'dashboard.billing.ariaLabel.billingTabs',
};

function BillingTabs() {
  const { formatMessage: fm } = useIntl();

  const routes = {
    methods: billingPaymentMethods,
    subscriptions: billingSubscriptions,
  };

  const billingRoutes = Object.values(routes);
  const currentTab = useCurrentTab(billingRoutes, routes.methods);

  const tabData = [
    {
      label: fm({ id: LOCALIZED_TEXT.paymentMethods }),
      to: routes.methods,
      value: routes.methods,
    },
    {
      label: fm({ id: LOCALIZED_TEXT.subscriptions }),
      to: routes.subscriptions,
      value: routes.subscriptions,
    },
  ];

  return (
    <Tabs aria-label={fm({ id: LOCALIZED_TEXT.billingTabsAriaLabel })} divider value={currentTab}>
      {tabData.map(({ label, to, value }) => (
        <Tab key={label} component={Link} label={label} to={to} value={value} />
      ))}
    </Tabs>
  );
}

export default BillingTabs;
